import { UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Layout, Menu, Space } from 'antd';
import { ItemType, MenuItemType } from 'antd/es/menu/interface';
import { memo, Suspense, useEffect, useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ModalChangePassword from 'src/components/ModalChangePassword';
import ModalConfirm from 'src/components/ModalConfirm';
import SpinnerLoader from 'src/libraries/SpinnerLoader';
import { RouteMenus } from 'src/routes/menu';
import { Routes } from 'src/routes/route';
import AuthService from 'src/services/auth.service';
import { useTaiKhoan } from 'src/stores';
import EVENT from 'src/utils/event-bus/event';

const svAuth = new AuthService();

function LayoutClient() {
  const { taiKhoan, clear } = useTaiKhoan();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    Array.from(document.getElementsByClassName('ant-menu-submenu-title')).forEach((i) => {
      i.classList.remove('ant-menu-item-selected');
      // @ts-ignore
      const dataSet = i?.dataset?.menuId?.split('-');
      if (dataSet) {
        if (dataSet[dataSet.length - 1] === `/${pathname.split('/')[1]}`) {
          i.classList.add('ant-menu-item-selected');
        }
      }
    });
  }, [pathname]);

  const handleLogout = async () => {
    try {
      await svAuth.logout();
    } catch (err) {
      console.log(err);
    }
    clear();
    navigate(Routes.LOGIN.path as string);
  };

  const avartarDropdownItems = useMemo<any>(
    () => [
      {
        label: <p onClick={() => EVENT.onShowModalChangePassword()}>Đổi mật khẩu</p>,
        key: 'change-password',
      },
      {
        label: <p onClick={handleLogout}>Đăng xuất</p>,
        key: 'logout',
      },
    ],
    [],
  );

  const menus = useMemo<ItemType<MenuItemType>[]>(() => {
    if (!taiKhoan) return [];

    return RouteMenus.map((i) => ({
      key: i.path,
      label: i.children ? i.title : <div onClick={() => navigate(i.path)}>{i.title}</div>,
      icon: i.icon,
      children: i.children
        ? i.children.map((e) => ({
            key: e.path,
            label: e.children ? e.title : <div onClick={() => navigate(e.path)}>{e.title}</div>,
            icon: e.icon,
            children: e.children
              ? e.children.map((x) => ({
                  key: x.path,
                  label: x.children ? x.title : <div onClick={() => navigate(x.path)}>{x.title}</div>,
                }))
              : undefined,
          }))
        : undefined,
    }));
  }, [taiKhoan]);

  const { innerHeight: height } = window;

  return (
    <>
      <Layout style={{ minHeight: '100vh' }}>
        <Layout.Header
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: 'var(--colorPrimary)',
          }}
        >
          <div
            style={{
              display: 'flex',
              margin: '16px 6px',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <div className="app-logo">
              <img src="/image/logo.png" alt="" width="40" />
            </div>
            <h3 style={{ color: 'white', marginLeft: 8 }}>Awake Kế toán</h3>
          </div>

          <Space>
            <div className="icon-wrapper">
              <Dropdown menu={{ items: avartarDropdownItems }} placement="bottomLeft">
                <Avatar size="large" style={{ backgroundColor: 'var(--colorNormal)' }} icon={<UserOutlined />} />
              </Dropdown>
            </div>
          </Space>
        </Layout.Header>

        <Layout>
          <Layout.Sider theme="dark" collapsible style={{ height: height - 104, overflow: 'scroll' }}>
            <Menu theme="dark" mode="inline" selectedKeys={[pathname]} items={menus} />
          </Layout.Sider>
          <Layout.Content
            style={{
              position: 'relative',
              maxHeight: height - 64,
              overflowY: 'scroll',
            }}
          >
            <Suspense fallback={<SpinnerLoader bg={false} />}>
              <Outlet />
            </Suspense>
          </Layout.Content>
        </Layout>
      </Layout>

      <ModalConfirm />
      <ModalChangePassword />
    </>
  );
}

export default memo(LayoutClient);
